import { AMSNoAccess } from 'legacy/hpscoutso/components/pages/amsEligibilityPartnersSearch/components/noAccess/AMSNoAccess'
import { APLLoadingPage } from 'legacy/hpscoutso/components/pages/aplCommon/APLLoadingPage'
import { APLAMSPageLayout } from 'legacy/hpscoutso/layout/aplPageLayout/APLAMSPageLayout'
import { FC, useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { PageContent } from './components/pageContent/PageContent'

export const AmsEligibilityPartnersSearch: FC = () => {
  const { translationIsLoading } = useContext(LanguageContext)
  const [isAllowed, setIsAllowed] = useState(true)
  const { roleIds, email } = useSelector(selectUser)

  useEffect(() => {
    let result = true
    if (!email.endsWith('@hp.com') && !roleIds.includes('APL AMS')) {
      result = false
    }

    setIsAllowed(result)
  }, [roleIds, email])

  if (!isAllowed) {
    return (
      <APLAMSPageLayout>
        <AMSNoAccess />
      </APLAMSPageLayout>
    )
  }

  return (
    <APLAMSPageLayout>
      {translationIsLoading ? <APLLoadingPage /> : <PageContent />}
    </APLAMSPageLayout>
  )
}
